import { Component, OnChanges, SimpleChanges, Input, OnDestroy } from '@angular/core';
import { ItemService } from '../services/item.service';
import { takeUntil, tap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { EventService } from '../services';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';

@Component({
    selector: 'more-like-this',
    styles: [`
        
    `],
    template: `
        <h3>Similar Items</h3>
        <spinner *ngIf="noTouching"></spinner>
        <mat-list *ngIf="!noTouching">
            <mat-list-item *ngFor="let item of items" [ngClass]="{ 'mlt-small-ff': isSmall }">
                <h4 mat-line><button mat-button color="primary" (click)="goToSimilar(item)">{{item.title}}</button></h4>
                <p mat-line>{{item.publishedDate | date }}</p>
            </mat-list-item>
        </mat-list>
`})
export class MoreLikeThisComponent implements OnChanges, OnDestroy {
    cleanupTime = new Subject<void>();
    @Input() item;
    noTouching: boolean;
    items: any;
    isSmall: boolean = true;
    
    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private itemService: ItemService,
                private eventService: EventService,
                private media: MediaObserver) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.item?.firstChange) {
            this.isSmall = this.media.isActive('xs');
            this.media.asObservable().pipe(takeUntil(this.cleanupTime)).subscribe(() => this.isSmall = this.isSmall = this.media.isActive('xs'));
        }
        if (changes.item) {
            this.noTouching = true;
            this.itemService.moreLikeThisItem(changes.item.currentValue.id)
            .pipe(tap(() => this.noTouching = false))
            .subscribe(items => this.items = items);
        }        
    }

    goToSimilar(item) {
        this.eventService.postEvent('item_morelikethis_clicked', this.eventService.formatItem(this.item));
        const returnTo = this.route.snapshot.queryParams.returnTo ? this.route.snapshot.queryParams.returnTo : this.router.url;
        this.router.navigate(['/digest', 'categories', 'uncategorized', 'topics', item.streamId, 'items', item.id], {
            queryParams: { returnTo }
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
